import React, { useState } from "react";
import PureHeader from "../../shared/FrontHeader/PureHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import FrontMainNav from "../../shared/FrontMainNav/FrontMainNav";
import { submitContactForm } from "../../../utils/submitContactForm";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
    _gotcha: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<
    "idle" | "success" | "error"
  >("idle");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setSubmitStatus("idle");
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (formData._gotcha) return;

    if (!formData.message.trim()) {
      setSubmitStatus("error");
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus("idle");

    try {
      await submitContactForm({
        nom_complet: formData.name,
        email: formData.email,
        tel: formData.phone,
        message: formData.message,
        subject: "Contact depuis le site",
        source: window.location.hostname || "",
      });
      setSubmitStatus("success");
      setFormData({ name: "", phone: "", email: "", message: "", _gotcha: "" });
    } catch {
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="landing-page-component">
      <PureHeader />
      <FrontMainNav />
      <div className="page-content contact-page-content">
        <div className="contact-page-container ">
          <section className="contact-form-section py-5">
            <h2 className="contact-form-title">Formulaire de contact</h2>
            <form
              className="contact-form"
              onSubmit={handleSubmit}
              noValidate
            >
              <input
                type="text"
                name="_gotcha"
                value={formData._gotcha}
                onChange={handleChange}
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                style={{ display: "none" }}
              />
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Nom et prénom"
                className="contact-form-input"
                aria-label="Nom et prénom"
              />
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Téléphone"
                className="contact-form-input"
                aria-label="Téléphone"
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
                className="contact-form-input"
                aria-label="Email"
              />
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Message"
                className="contact-form-textarea"
                rows={6}
                aria-label="Message"
                required
              />
              <button
                type="submit"
                className="contact-form-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Envoi..." : "ENVOYER"}
              </button>
              {submitStatus === "success" && (
                <p className="contact-form-success" role="status">
                  Message envoyé. Nous vous recontacterons rapidement.
                </p>
              )}
              {submitStatus === "error" && (
                <p className="contact-form-error" role="alert">
                  L&apos;envoi a échoué. Veuillez réessayer dans quelques instants.
                </p>
              )}
            </form>
          </section>
        </div>
      </div>
      <FrontFooter />
    </div>
  );
}

export default Contact;
